module.exports = __webpack_public_path__ + "static/media/888B.3d3b31af.pdf";